module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "register_lx"
    }
  }, [_c('h3', {
    staticClass: "color_5babf4 text-center login_title"
  }, [_vm._v("请选择注册开发者类型")]), _vm._v(" "), _c('section', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-center"
  }, [_c('a', {
    staticClass: "router_link_a",
    attrs: {
      "href": "javascript:void(0);",
      "to": "/developer_register"
    },
    on: {
      "click": _vm.getparentdata
    }
  }, [_c('img', {
    attrs: {
      "src": require("./img/icon-individual-developers.png"),
      "width": "140",
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "color_f"
  }, [_vm._v("个人开发者")]), _vm._v(" "), _c('h5', {
    staticClass: "color_9"
  }, [_vm._v("适用于个人开发者，免费发布应用和开放部分数据接口。")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-center"
  }, [_c('a', {
    staticClass: "router_link_a",
    attrs: {
      "href": "javascript:void(0);",
      "to": "/enterprise_developers"
    },
    on: {
      "click": _vm.getcompanydata
    }
  }, [_c('img', {
    attrs: {
      "src": require("./img/icon-enterprise-developers.png"),
      "width": "140",
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "color_f"
  }, [_vm._v("企业开发者")]), _vm._v(" "), _c('h5', {
    staticClass: "color_9"
  }, [_vm._v("适用于公司、企业、机构等组织注册，可以获得更多的数据接口权限。")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-375c8638"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/loginGroup/register_lx.vue
// module id = 1249
// module chunks = 1